import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import { COLORES } from '../../../../config/colores'
// import TablaPedidosDeBrutoACalado from '../../../Pesado/containers/pedidoCamionesEnCalado/TablaPedidosDeBrutoACalado'
import PedidosEgresoCalado from '../../../Pesado/components/bruto/PedidosEgresoCalado'

function PedidosDeCamionesBruto () {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xl'
        fullWidth
      >
        <DialogView
          cancelCallback={handleClose}
          title=' '
          content={<PedidosEgresoCalado />}
        />
      </Dialog>
      <Button
        size='small'
        className='btn-reportes-bruto'
        variant='contained'
        style={{ color: 'white', backgroundColor: COLORES.violet, borderRadius: '22px', margin: '8px auto' }}
        onClick={handleOpen}
      >
        Ver pedidos de camiones
      </Button>

    </>
  )
}

export default PedidosDeCamionesBruto
